var exports = {
  "kL": "xfd349460--270d47--container",
  "HU": "xfd349460--270d47--aside",
  "T1": "xfd349460--270d47--call",
};

module.exports = exports;
